import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../axiosConfig';
import BoreholeDetailView from './BoreholeDetailView';

const BoreholeDetailWrapper = ({ showToast }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [borehole, setBorehole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBoreholeDetail();
  }, [id]);

  const fetchBoreholeDetail = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/boreholes/`);
      const foundBorehole = response.data.data.find(b => b.id === parseInt(id));
      if (foundBorehole) {
        setBorehole(foundBorehole);
      }
    } catch (error) {
      console.error('시추공 상세 조회 실패:', error);
    } finally {
      setLoading(false);
    }
  };

  const boreholeUpdateDelegate = (updatedBorehole) => {
    setBorehole(updatedBorehole);
  };

  if (loading) {
    return (
      <div className="flex-1 flex items-center justify-center bg-secondary-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
          <p className="text-secondary-600">로딩 중...</p>
        </div>
      </div>
    );
  }

  if (!borehole) {
    return (
      <div className="flex-1 flex items-center justify-center bg-secondary-50">
        <div className="text-center">
          <p className="text-secondary-600">데이터를 찾을 수 없습니다</p>
          <button
            onClick={() => navigate('/boreholes')}
            className="mt-4 px-4 py-2 bg-primary-600 text-white rounded-xl hover:bg-primary-700 transition-colors"
          >
            목록으로 돌아가기
          </button>
        </div>
      </div>
    );
  }
  return (
    <div className="flex-1 overflow-auto bg-secondary-50">
      <div className="max-w-7xl mx-auto p-8">
        {/* 헤더 */}
        <div className="mb-6">
          <button
            onClick={() => navigate('/boreholes')}
            className="flex items-center space-x-2 text-secondary-600 hover:text-secondary-900 transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            <span className="text-sm font-medium">목록으로 돌아가기</span>
          </button>
        </div>

        <BoreholeDetailView
          selectedBorehole={borehole}
          showToast={showToast}
          boreholeUpdateDelegate={boreholeUpdateDelegate}
        />
      </div>
    </div>
  );
};

export default BoreholeDetailWrapper;
